export default {};
throw new Error(`Could not resolve "gsap/Observer" imported by "@appletosolutions/reactbits". Is it installed?`)